import { ReactMultiEmail, isEmail } from 'react-multi-email';
import './formMultiEmailInput.css';

import FormTextInput from "./FormTextInput";
import { Controller } from 'react-hook-form';
import { Pmb } from './Typography';

const UncontrolledFormMultiEmailInput = ({ value, onChange, placeholder, label, ...rest }) => {
    const emailMatch = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    // return (<FormTextInput {...rest} rules={{ ...rest.rules, pattern: { value: emailMatch, message: "invalid email" } }} />)
    return (
        <div style={rest.style}>
            <Pmb>{label}</Pmb>
            <ReactMultiEmail
                placeholder={placeholder}
                emails={value?.map(v => v.email)}
                onChange={(emails) => {
                    const newValue = emails.map(email => ({ email }))
                    onChange(newValue)
                }}
                autoFocus={true}
                // onFocus={() => setFocused(true)}
                // onBlur={() => setFocused(false)}
                getLabel={(email, index, removeEmail) => {
                    return (
                        <div data-tag key={index}>
                            <div data-tag-item>{email}</div>
                            <span data-tag-handle onClick={() => removeEmail(index)}>
                                ×
                            </span>
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default ({ name, control, rules, ...rest }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { ...fieldProps } }) => (
                <UncontrolledFormMultiEmailInput {...fieldProps} {...rest} />
            )}
        />
    );
};